<template>
  <layout-dashboard>
    <div class="card">
      <div class="card-content">
        <h5>Generar Recibo de Pago</h5>
        <div class="row">
          <div class="input-field col s12">
            <select v-model="form.nomina">
              <option :value="index" v-for="(item, index) in nominas" :key="index">{{ item.descripcion }}</option>
            </select>
            <label>Seleccione una nomina</label>
          </div>
        </div>
        <div class="row">
          <div class="input-field col s12">
            <select v-model="form.year">
              <option :value="item" v-for="(item, index) in years" :key="index">{{ item }}</option>
            </select>
            <label>Seleccione una nomina</label>
          </div>
        </div>
        <div class="row">
          <div class="input-field col s12">
            <select v-model="form.month">
              <option value="" disabled selected v-if="months == null">No hay meses disponibles</option>
              <option :value="item.fecha_p_hasta" v-for="(item, index) in months" :key="index">{{ item.month }}</option>
            </select>
            <label>Seleccione un mes</label>
          </div>
        </div>
        <div class="row">
          <div class="col s12">
            <label>
              <input type="checkbox" v-model="form.sendemail" />
              <span>Enviar al correo electrónico el recibo de pago generado</span>
            </label>
          </div>
        </div>
      </div>
      <div class="card-action">
        <button v-on:click="generarRecibo" class="waves-effect waves-light btn" :disabled="button">Generar recibo de Pago</button>
        <router-link :to="{ name: 'home' }" class="btn-flat button-back"><i class="fas fa-arrow-left"></i> Volver</router-link>
      </div>
    </div>
    <div id="generar-recibo" class="modal">
      <div class="modal-content">
        <h4>Desea generar el recibo de pago</h4>
      </div>
      <div class="modal-footer">
        <button class="modal-close waves-effect waves-green btn-flat">Cancelar</button>
        <button v-on:click="generarReciboConfirm" class="waves-effect waves-green btn">Generar</button>
      </div>
    </div>
    <div id="descargar-recibo" class="modal">
      <div class="modal-content">
        <h4><i class="fas fa-check"></i> Archivo Generado con éxito</h4>
      </div>
      <div class="modal-footer">
        <span class="btn-small btn-flat disabled">
          <i class="fas fa-file-pdf"></i> {{ recibo.filename }}
        </span>
        <a id="linkdownload" class="waves-effect waves-green btn"><i class="fas fa-download"></i> Descargar Archivo</a>
      </div>
    </div>
    <loader :show="loaderStatus"></loader>
  </layout-dashboard>
</template>

<script>
import LayoutDashboard from '@/components/layouts/Dashboard'
import * as M from 'materialize-css'
import Loader from '@/components/Loader'
import axios from 'axios'

export default {
  name: 'hello',
  data () {
    return {
      nominas: this.$store.getters.currentUser.nominas,
      recibo: {
        blob: null,
        filename: null
      },
      loaderStatus: false,
      form: {
        nomina: 0,
        year: null,
        month: null,
        sendemail: false
      }
    }
  },
  components: {
    LayoutDashboard,
    Loader
  },
  methods: {
    loadFormSelect () {
      var elems = document.querySelectorAll('select')
      var options = document.querySelectorAll('option')
      M.FormSelect.init(elems, options)
    },
    generarRecibo () {
      var elems = document.getElementById('generar-recibo')
      var instance = M.Modal.init(elems)
      instance.open()
    },
    generarReciboConfirm () {
      var elems = document.getElementById('generar-recibo')
      var instance = M.Modal.init(elems)
      instance.close()

      this.loaderStatus = true
      var values = {
        // nomina: this.$store.getters.currentUser.nominas[this.form.nomina].tipo_nomina,
        nomina: this.form.nomina,
        year: this.form.year,
        month: this.form.month,
        sendemail: this.form.sendemail
      }
      axios.post(process.env.ROOT_API + '/api/recibo', values, {
        responseType: 'blob'
      })
        .then(
          (response) => {
            elems = document.getElementById('descargar-recibo')
            var options = {
              onCloseEnd: () => {
                document.documentElement.style.overflow = '' // firefox, chrome
                document.body.style.overflow = ''
                document.body.scroll = 'yes' // ie only
              }
            }
            instance = M.Modal.init(elems, options)
            instance.open()

            this.loaderStatus = false

            this.recibo.filename = 'recibo-' + values.nomina + '-' + values.month + '.pdf'
            let blob = new Blob([response.data], { type: 'application/pdf' })
            let link = document.getElementById('linkdownload')
            link.href = window.URL.createObjectURL(blob)
            link.download = this.recibo.filename
          }
        )
        .catch(
          (err) => {
            this.loaderStatus = false
            // err.response.data.message
            this.errors = err.response.data.errors
            // console.log(['hubo un error', err.response.data])
            M.toast({html: 'Ocurrio un error al guardar el formulario', classes: 'red'})
          }
        )
    }
  },
  computed: {
    years () {
      var years = []
      for (var key in this.nominas[this.form.nomina].years) {
        years.unshift(key)
      }
      // console.log(this.nominas[this.form.nomina].years)
      this.form.year = years[0]
      return years
    },
    months () {
      this.form.month = null
      if (this.nominas[this.form.nomina].years[this.form.year] != null) {
        this.form.month = this.nominas[this.form.nomina].years[this.form.year][0].fecha_p_hasta
        // console.log(this.nominas[this.form.nomina].years[this.form.year][0].mm)
      }
      return this.nominas[this.form.nomina].years[this.form.year]
    },
    button () {
      if (
        this.$store.getters.currentUser.nominas[this.form.nomina].tipo_nomina && this.form.year && this.form.month) {
        return false
      }
      return true
    }
  },
  mounted () {
    document.title = 'Recibos de Pago'
  },
  updated () {
    this.loadFormSelect()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  h5 {
    font-size: 16px;
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/components/RRHH/Recibo.vue